import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionDetail from './sectionDetail';
import ForOFor from './../container/forOFor';
import { fetchSectionDetail } from './../actions.js';
import { getSection } from './../../ui/src/actions.js';
import { getProp } from '../../ui/src/utilities';

class SectionContentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const idFromUrl = this.getUrlId(this.props);
    this.init(idFromUrl || this.props.id);
  }

  componentWillReceiveProps(nextProps) {
    const idFromUrl = this.getUrlId(nextProps);
    if (idFromUrl) {
      // direct access
      if (idFromUrl !== this.getUrlId(this.props)) {
        this.init(idFromUrl);
      }
    } else {
      // indirect access
      if (nextProps.id !== this.props.id) {
        this.init(nextProps.id);
      }
    }
  }

  getUrlId(props) {
    let id = getProp(props, 'params.id', null);
    if (id !== null) {
      return Number(id);
    }
    return null;
  }

  init(id) {
    if (id) {
      this.props.dispatch(getSection(process.env.REACT_APP_CONTENT_SPACE, id));
      this.props.dispatch(fetchSectionDetail(id));
    }
  }

  render() {
    const idFromUrl = this.getUrlId(this.props);
    const id = idFromUrl || this.props.id;
    if (!id || this.props.isNotFound) {
      return <ForOFor />;
    }
    return <SectionDetail id={id} />;
  }
}

SectionContentItem.fetchData = ({
  store,
  renderProps: { location, params },
}) => {
  let id = getProp(params, 'id', null);
  if (id !== null) {
    return store.dispatch(getSection(process.env.REACT_APP_CONTENT_SPACE, id));
  }
  return Promise.resolve();
};

SectionContentItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.number,
  isNotFound: PropTypes.bool,
  articles: PropTypes.array.isRequired,
};

export default connect(state => {
  return {
    isNotFound: state.sections.httpStatus === 404,
    articles: state.sectionDetail.articles.articles,
  };
})(SectionContentItem);



// WEBPACK FOOTER //
// ./src/app/container/sectionContentItem.js